export const Abstract03Icon = () => {
  return (
    <svg
      width="125"
      height="126"
      viewBox="0 0 125 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.291 29.9605L97.7549 56.4961H68.481V27.2217L95.0166 0.686104H124.291V29.9605Z"
        fill="white"
      />
      <path
        d="M68.4805 99.0103L95.0161 125.546H124.29V96.2715L97.7548 69.7359H68.4805V99.0103Z"
        fill="url(#paint0_linear_1866_18389)"
      />
      <path
        d="M0.291016 29.9605L26.8266 56.4961H56.101V27.2217L29.5654 0.686104H0.291016V29.9605Z"
        fill="white"
      />
      <path
        d="M56.101 99.0103L29.5654 125.546H0.291016V96.2715L26.8266 69.7359H56.101V99.0103Z"
        fill="url(#paint1_linear_1866_18389)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18389"
          x1="96.3855"
          y1="69.7359"
          x2="96.3855"
          y2="125.546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1866_18389"
          x1="28.196"
          y1="69.7359"
          x2="28.196"
          y2="125.546"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
